import { combineReducers } from 'redux';

const defaultSelectedNumbers = [];
const selectedNumbers = (state = defaultSelectedNumbers, action) => {
  switch (action.type) {
    case 'SELECTED_NUMBER':
      return [...state, action.telephoneNumber];
    case 'RESET_SELECTED_NUMBER':
      return action.telephoneNumber;
    default:
      return state;
  }
};

const e911AddressModal = false;
const showE911AddressModal = (state = e911AddressModal, action) => {
  switch (action.type) {
    case 'SHOW_E991MODAL':
      return true;
    case 'HIDE_E991MODAL':
      return false;
    default:
      return state;
  }
};

const queryLrnModal = false;
const showQueryLrnModal = (state = queryLrnModal, action) => {
  switch (action.type) {
    case 'SHOW_QUERY_LRN_MODAL':
      return true;
    case 'HIDE_QUERY_LRN_MODAL':
      return false;
    default:
      return state;
  }
};

var data = {};
const defaultState = [];
const filterEmails = (state = defaultState, action) => {
  switch (action.type) {
    case 'NUMBER_COMPANY_EMAILS_SUCCESS': {
      data[action.companyName] = action.emails.emails;

      return {
        ...state,
        emails: data,
      };
    }
    default:
      return state;
  }
};

export default combineReducers({
  selectedNumbers,
  showE911AddressModal,
  filterEmails,
  showQueryLrnModal,
});
